/**
 * Mixin con un metodo para hacer resize a la imagen
 * se puede enviar en los parametros tanto el ancho como la calidad de la imagen de salida
 * si el ancho o la calidad no se envian estos seran 800 y 1.0
 * si la imagen el ancho es menor al el que se indica en la funcion no se reducira
 * el formato de salida es webp
 */
export default {
	methods: {
		async compressImage(inputFile, maxWidth = 800, quality = 1.0) {
			// Crear una imagen a partir del archivo seleccionado
			const img = new Image();
			img.src = URL.createObjectURL(inputFile);

			// Esperar a que la imagen se cargue antes de continuar
			await new Promise(resolve => {
				img.onload = resolve;
			});

			// Verificar si la imagen ya está dentro del tamaño máximo especificado
			if (img.width <= maxWidth) {
				// Convertir la imagen al formato WebP
				const outputFormat = 'image/webp';
				const inputFormat = inputFile.type;
				const output = new File([inputFile], inputFile.name, {
					type: outputFormat,
					lastModified: Date.now(),
				});

				console.log(`Tamaño original: ${(inputFile.size / 1024).toFixed(2)} KB`);
				console.log(`Tamaño comprimido: ${(output.size / 1024).toFixed(2)} KB`);
				console.log(`Reducción de tamaño: ${(1 - output.size / inputFile.size) * 100}%`);
				console.log(`Formato de entrada: ${inputFormat}`);
				console.log(`Formato de salida: ${outputFormat}`);

				return output;
			}

			// Calcular el ancho y alto redimensionados
			let newWidth = maxWidth;
			let newHeight = Math.round((img.height * maxWidth) / img.width);

			// Crear un elemento canvas
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');

			// Establecer el tamaño del canvas para que coincida con el de la imagen redimensionada
			canvas.width = newWidth;
			canvas.height = newHeight;

			// Redimensionar la imagen en el canvas
			ctx.drawImage(img, 0, 0, newWidth, newHeight);

			// Convertir el canvas redimensionado en un objeto File
			return new Promise(resolve => {
				canvas.toBlob(
					blob => {
						// Crear un nuevo objeto File a partir del archivo comprimido
						const compressedFile = new File([blob], inputFile.name, {
							type: 'image/webp',
							lastModified: Date.now(),
						});

						// Mostrar las diferencias entre la imagen original y la imagen comprimida en la consola
						console.log(`Tamaño original: ${(inputFile.size / 1024).toFixed(2)} KB`);
						console.log(
							`Tamaño comprimido: ${(compressedFile.size / 1024).toFixed(2)} KB`
						);
						console.log(
							`Reducción de tamaño: ${(1 - compressedFile.size / inputFile.size) *
								100}%`
						);
						console.log(`Formato de entrada: ${inputFile.type}`);
						console.log(`Formato de salida: image/webp`);

						resolve(compressedFile);
					},
					'image/webp',
					quality
				);
			});
		},
	},
};
